
import { post } from '@/utils/http'
// 签到日历
export const outMemory = function (data) {
  return post({
      url: "/app/userPair/our-memory",
      data
  })
}